import { ChatLauncher } from '../ChatLauncher.jsx'
import { ChatPanel } from '../ChatPanel.jsx'
import { useChatLayout } from '../../../context/ChatLayoutContext.jsx'
import { getFloatingBubblePanelPlacement } from '../../../lib/floatingAnchor.js'
import { cn } from '../../../lib/cn.js'

/**
 * Floating bubble: a launcher in the bottom-right corner that toggles
 * a fixed-size chat panel. The panel mounts whenever the bubble is
 * open so message state survives close/reopen cycles.
 */
export function FloatingBubbleLayout({
  conf,
  messages,
  isTyping,
  onSend,
  ochatbot,
  onLeadFormSubmit,
  onOrderStatusResult,
  ...panelRest
}) {
  const { open, toggleChat, closeChat } = useChatLayout()
  const { wrapperStyle, innerOriginClass } = getFloatingBubblePanelPlacement(conf || {})

  return (
    <>
      <ChatLauncher
        open={open}
        onToggle={toggleChat}
        label={conf?.widgetTitle || 'Chat with us'}
        conf={conf}
      />
      <div style={wrapperStyle}>
        <div
          data-state={open ? 'open' : 'closed'}
          className={cn(
            innerOriginClass,
            'h-[560px] w-[380px] max-h-[calc(100vh-7rem)] max-w-[calc(100vw-2rem)]',
            'rounded-[var(--radius-widget)] overflow-hidden border border-[var(--color-border)] shadow-[var(--shadow-widget)]',
            'transition-[transform,opacity] duration-200 ease-out',
            open
              ? 'pointer-events-auto scale-100 opacity-100'
              : 'pointer-events-none scale-95 opacity-0',
          )}
        >
          {open && (
            <ChatPanel
              conf={conf}
              messages={messages}
              isTyping={isTyping}
              onSend={onSend}
              onClose={closeChat}
              ochatbot={ochatbot}
              onLeadFormSubmit={onLeadFormSubmit}
              onOrderStatusResult={onOrderStatusResult}
              {...panelRest}
            />
          )}
        </div>
      </div>
    </>
  )
}
